import { styled } from 'styled-system/jsx'

const PageRoot = styled('div', {
  base: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    background:
      'linear-gradient(135deg, {colors.quickpass.surfaceCool} 0%, {colors.quickpass.surface} 60%, #FEF0FF 100%)',
  },
})

const ContentRegion = styled('main', {
  base: {
    flex: '1',
    width: '100%',
    paddingX: '24px',
    paddingTop: '12px',
    paddingBottom: '48px',
    display: 'flex',
    justifyContent: 'center',
  },
})

const ContentWidthLimiter = styled('div', {
  base: {
    width: '100%',
  },
  variants: {
    contentMaxWidth: {
      narrow: { maxWidth: '520px' },
      standard: { maxWidth: '760px' },
      wide: { maxWidth: '1080px' },
    },
  },
  defaultVariants: {
    contentMaxWidth: 'standard',
  },
})

export { PageRoot, ContentRegion, ContentWidthLimiter }
